import { formatDateTime } from '@backoffice-frontend/common'
import { FeatureTogglesView } from '@backoffice-frontend/feature-toggle'
import {
  Caption,
  MoiaTopBar,
  MoiaTopBarTitle,
  MoiaViewBox,
} from '@backoffice-frontend/patterns'
import { Restricted } from '@backoffice-frontend/restricted'
import { useBackofficeLoggedInUser } from '@backoffice-frontend/user-management-ui'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { PersonIcon } from '@moia-dev/pace-icons'
import { useTranslation } from 'react-i18next'
import { CredentialsView } from './CredentialsView'

import { AccountDivider, AccountLayout } from './components/AccountLayout'

import { PermissionsView } from './PermissionsView'
import { VersionView } from './VersionView'

export const AccountView = () => {
  const { t } = useTranslation()
  const { user } = useBackofficeLoggedInUser()

  return (
    <MoiaViewBox>
      <title>{t('authenticatedAppView_account_header')}</title>
      <MoiaTopBar
        leading={
          <MoiaTopBarTitle
            icon={<PersonIcon />}
            title={t('authenticatedAppView_account_header')}
          />
        }
      />
      <Restricted requiredRights={[BoumRight.DEV_USE_FEATURE_TOGGLES]}>
        <AccountLayout
          header={t('authenticatedAppView_features_header')}
          subheader={t('authenticatedAppView_features_caption')}
        >
          <FeatureTogglesView />
        </AccountLayout>
        <AccountDivider />
      </Restricted>
      <CredentialsView />

      <PermissionsView />

      <VersionView />
      {user && (
        <div
          css={theme => ({
            marginTop: theme.space.Space2,
            display: 'flex',
            alignItems: 'center',
            gap: theme.space.Space2,
          })}
        >
          <Caption>
            {t('common_createdAt_label')} {formatDateTime(user.createDate)}
            {' • '}
            {t('common_modifiedAt_label')}{' '}
            {formatDateTime(user.lastModifiedDate)}
          </Caption>
        </div>
      )}
    </MoiaViewBox>
  )
}
